import './compromiso.css';
import banner from '../assets/images/compromiso.png';

function Compromiso() {
  return (
    <section className="compromiso">

      {/* 🔥 Banner superior */}
      <div className="compromiso-banner">
        <img src={banner} alt="Compromiso" />
      </div>

      {/* 🔥 Contenido */}
      <div className="compromiso-container">
        <div className="compromiso-left">
          <h2>Nuestro<br />Compromiso</h2>
        </div>

        <div className="compromiso-right">
          <p>
            En COPAC trabajamos con estándares sostenibles y producción responsable.
          </p>

          <ul>
            <li>✔ Certificaciones ambientales</li>
            <li>✔ Uso eficiente de recursos</li>
            <li>✔ Innovación en procesos</li>
            <li>✔ Compromiso con el medio ambiente</li>
          </ul>
        </div>
      </div>

      {/* 🔥 TÍTULO FLOTANTE */}
      <div className="equipo-title">
        Nuestros Clientes
      </div>

    </section>
  );
}

export default Compromiso;